export enum HedgeOrderBy {
  NAME = 'name',
  PLACED_AT = 'placedAt',
  EXPIRES_AT = 'expiresAt',
}
